import MsalAuthProvider from "./AuthProvider";

export default MsalAuthProvider;
